import React from 'react';
import { useTheme } from '../context/ThemeContext';

const BookmarkIcon = ({ filled = false, forceColor = null }) => {
  const { darkMode } = useTheme();
  
  // If forceColor is specified, use that. Otherwise, use theme-based colors
  const getColor = () => {
    if (forceColor) return forceColor;
    return darkMode ? "#fff" : "#333333";
  };
  
  const color = getColor();
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill={filled ? color : "none"}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
    </svg>
  );
};

export default BookmarkIcon;
